import { Formik, FormikActions, FormikProps } from 'formik';
import moment from 'moment';
import Moment from 'moment';
import 'moment/locale/en-gb';
import 'moment/locale/tr';
import 'moment/locale/ar';
import { Log } from 'ng2-logger';
import React, { Dispatch } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'reactstrap';
import { FileUpload } from '../../components/file-upload/main';
import { DatetimeFormik } from '../../components/input/date-time/date-time-formik';
import Quil from '../../components/input/quil/main';
import { SelectAsync } from '../../components/input/select/main';
import Input from '../../components/input/text/input-formik';
import { Common } from '../../core/common';
import Translator from '../../core/i18n';
import { IAction, IAppState } from '../../models/action/core';
import * as forumPageActions from '../../store/actions/forum';
import { Notification } from '../../components/notification/main';
import {
    IHelpDeskProps,
    IHelpDeskState,
    IHelpdeskListItem,
    HelpDeskSearchInitialValues,
    IHelpDeskChatItem,
    IHelpDeskListProps
} from '../../models/pages/helpdesk';
import imgAnn from '../../static/images/announcement.svg';
import * as Actions from '../../store/actions/helpdesk';
import { Table } from 'reactstrap';
import SortedColumn from '../../components/table/sorted-column';
import Paginate from '../../components/table/paginate';
import { EModuleType } from '../../models/components/input-quil.d';
import { Guid } from 'guid-typescript';
import { ActivityTypeEnums } from '../../models/enums/ActivityType'
import ChatEmojiPicker from '../messages/chatEmojiPicker';
import ReactGA from 'react-ga4';

const _logger = Log.create('HelpDesk');
const T = Translator.create();
const spinnerId = 'helpDeskLoadingMain';
let _common: Common;
const date = new Date()

if (T.i18next.language === 'tr') {
    moment.locale('tr');
} else if (T.i18next.language === 'en') {
    moment.locale('en');
}
else if (T.i18next.language === 'ar') {
    moment.locale('ar');
}

class HelpDeskMain extends React.Component<IHelpDeskProps, IHelpDeskState> {
    public picker: HTMLDivElement | null = null;
    isHelpModalOpen: boolean | undefined;
    ishelpDeskChatModalOpen: boolean | undefined;
    uppyInstance: any;
    chatEmojiPicker: any;
    quillRef: Quil | null = null;
    private messagesEndRef: React.RefObject<HTMLDivElement>;

    constructor(props: any) {
        super(props);

        _common = new Common();
        this.addNewHelpModal = this.addNewHelpModal.bind(this);
        this.setCloseHelpModal = this.setCloseHelpModal.bind(this);
        //this.state.filterInitialValues.fileInputKey = this.generateFileUploadKey();
        this.showHelpModal = this.showHelpModal.bind(this);
        this.setCloseShowHelpModal = this.setCloseShowHelpModal.bind(this);
        this.sendMessageCallback = this.sendMessageCallback.bind(this);
        this.getCreate = this.getCreate.bind(this);
        this.afterCreate = this.afterCreate.bind(this);
        this.messagesEndRef = React.createRef(); 

        this.state = {
            filters: Object.assign({}, HelpDeskSearchInitialValues),
            isHelpModalOpen: false,
            ishelpDeskChatModalOpen: false,
            isSearched: false,
            selectedHelpDeskItem: {},
            selectedHelpDeskId: '',
            selectedHelpDeskRefId: '',
            helpDeskMessage: '',
            filterInitialValues: {
                categories: '',
                status: '',
                subject: '',
                createSubject: '',
                beginCreatedDate: '',
                endCreatedDate: '',
                helpDeskCreateDate: '',
                fileInputKey: '',
                page: 1
            },
            description: '',
            endCreatedDate: '',
            isSelected: false,
            categories: [],
            status: [],
            assignedUser: [],
            helpDeskList: [],
            helpDeskChat: [],
            fileId: '',
            showFileUploader: false,
            showFileUploaderCount: 0,
            fileUploaded: false,
            fileUploadKey: this.generateFileUploadKey(),
            messageTextAreaValue: '',
            getQuillToolbarModule: this.getQuillToolbarModule(),
            showEmojiPicker: false,
            isLoadingProcess: false
        };
        this.onSubmit.bind(this);
        this.onCreateSubmit.bind(this);
    }

    scrollToBottom = () => {
        if (this.messagesEndRef.current) {
            this.messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }

    componentDidUpdate() {
        this.scrollToBottom();
       
    }
    

    componentDidMount() {
        this.getList();
        // this.getAssignedUser();
        const helpdeskModuleId = 140; // helpdesk modülünün ID'si
        if (!this.props.moduleItems.includes(helpdeskModuleId)) {
            // Duyuru modülü etkin değilse kullanıcıyı /error sayfasına yönlendir
            window.location.href = '/almsp/u/error/';
        }
    }

    onSubmit = async (values: any, formikActions: FormikActions<any>) => {
        this.state.filterInitialValues.subject = values.subject;
        this.state.filterInitialValues.categories =
            values.categoryTypeId && values.categoryTypeId.length > 0 ? values.categoryTypeId[0] : '';
        this.state.filterInitialValues.status = values.statusId && values.statusId.length > 0 ? values.statusId : '';
        this.state.filterInitialValues.helpDeskCreateDate = values.helpDeskCreateDate ? values.helpDeskCreateDate : '';
        this.state.filterInitialValues.page = 1;
        this.setState(this.state)
        this.getList();
        formikActions.setSubmitting(false);
    };

    onCreateSubmit = async (values: any, formikActions: FormikActions<any>) => {
        this.setState({ isLoadingProcess: true })
        this.state.filterInitialValues.createSubject = values.createSubject;
        this.state.filterInitialValues.categories = values.categoryTypeId && values.categoryTypeId.length > 0 ? values.categoryTypeId : '';
        this.getCreate();
        formikActions.setSubmitting(false);
        this.state.filterInitialValues.createSubject = '';
    };
    descriptionOnChange = (event: any) => {
        if (event !== this.state.description) {
            this.setState({ description: event });
        }
    };
    messageOnChange = (event: any) => {
        if (event !== this.state.messageTextAreaValue) {
            this.setState({ messageTextAreaValue: event });
        }
    };
    public addNewHelpModal() {
        ReactGA.event({
            category: window.location.host,
            action: 'G_CREATE_HELP_CLICKED',
            label: 'G_CREATE_HELP_CLICKED',
            nonInteraction: true,
        });
        this.setState({ isHelpModalOpen: true });
    }
    public setCloseHelpModal() {
        this.setState({ isHelpModalOpen: false });
    }
    public showHelpModal() {
        this.setState({ ishelpDeskChatModalOpen: true });
    }
    public setCloseShowHelpModal() {
        this.setState({ ishelpDeskChatModalOpen: false });
    }
    getAssignedUser() {
        this.props.dispatch(Actions.setHelpdeskAssignedUser('', '', '', '', ''));
    }
    sendMessageCallback() {
        this.props.dispatch(Actions.getHelpdeskMessage(this.state.selectedHelpDeskId!, 1000, 0));
    }
    sendHandler() {
        if (this.state.showFileUploaderCount! <= 0 && !this.state.messageTextAreaValue) {
            Notification.setNotification('error', T.t('r_forum_message_content_not_found'), 'topRight');
        } else {
            this.props.dispatch(
                forumPageActions.sendForumMessageByThreadId(
                    this.state.messageTextAreaValue,
                    this.state.selectedHelpDeskRefId!,
                    '',
                    '',
                    this.state.fileUploadKey,
                    this.sendMessageCallback
                )
            );
            this.resetFileUploader();
            this.setState({ messageTextAreaValue: '', showFileUploaderCount: 0 });
            this.handleResetText()
        }
    }

    handleResetText() {
        if (this.quillRef) {
            this.quillRef.state.description = "";
        }
    }

    deleteHandler() {
        this.props.dispatch(
            forumPageActions.deleteAnswerMessageGetAction(
                this.state.selectedHelpDeskRefId!,
                this.state.selectedHelpDeskMessageId!,
                0,
                this.state.helpDeskMessage!,
                this.sendMessageCallback
            )
        );
        this.props.dispatch(Actions.getHelpdeskMessage(this.state.selectedHelpDeskId!, 1000, 0));
    }
    public async onMessageClick(helpdeskId: string, helpDeskIdRef: string, message: string) {
        if (this.props.helpDeskList && this.props.helpDeskList.length > 0) {
            const index = this.props.helpDeskList.findIndex(x => x.helpDeskId == helpdeskId)
            this.setState({
                ishelpDeskChatModalOpen: true,
                selectedHelpDeskItem: this.props.helpDeskList[index],
                selectedHelpDeskRefId: helpDeskIdRef,
                helpDeskMessage: message,
                selectedHelpDeskId: helpdeskId,
            });
        }

        this.props.dispatch(Actions.getHelpdeskMessage(helpdeskId, 1000, 0));
    }
    afterCreate = () => {
        this.state.filterInitialValues.subject = '';
        this.state.filterInitialValues.categories = '';
        this.state.filterInitialValues.page = 1;
        this.setState({ description: '', isLoadingProcess: true })
        this.props.dispatch(
            Actions.getHelpdeskList(
                this.state.filterInitialValues.status,
                this.state.filterInitialValues.categories,
                this.state.filterInitialValues.subject!,
                this.state.filterInitialValues.beginCreatedDate!,
                this.state.filterInitialValues.endCreatedDate!,
                '',
                10,
                this.state.filterInitialValues.page,
                this.state.filters.orderBy ? this.state.filters.orderBy : ''
            )
        );
    }
    getList = () => {
        this.props.dispatch(
            Actions.getHelpdeskList(
                this.state.filterInitialValues.status,
                this.state.filterInitialValues.categories,
                this.state.filterInitialValues.subject!,
                this.state.filterInitialValues.beginCreatedDate!,
                this.state.filterInitialValues.endCreatedDate!,
                '',
                10,
                this.state.filterInitialValues.page,
                this.state.filters.orderBy ? this.state.filters.orderBy : ''
            )
        );
    }

    getCreate() {
        if (this.state.filterInitialValues.categories && this.state.filterInitialValues.createSubject && _common.removeHtmlTags(this.state.description)) {
            this.props.dispatch(
                Actions.getHelpdeskCreate(this.state.filterInitialValues.createSubject, this.state.filterInitialValues.categories, this.state.description, '', this.afterCreate)
            );
            this.setCloseHelpModal();
            this.setState({ isLoadingProcess: false })

        }
        else if (!this.state.filterInitialValues.createSubject) {
            Notification.setNotification('error', T.t('r_helpdesk_subject_error'), 'topRight');
        }
        else if (!this.state.filterInitialValues.categories) {
            Notification.setNotification('error', T.t('r_helpdesk_category_error'), 'topRight');
        }
        else if (!_common.removeHtmlTags(this.state.description)) {
            Notification.setNotification('error', T.t('r_description_required_validation'), 'topRight');
        }
        this.setState({ isLoadingProcess: false })

    }
    createAndSubmit = async (formik: FormikProps<any>) => {
        this.setState({ isSearched: false });
        let isCompleted: boolean = true;
        if (isCompleted) {
            formik.submitForm();
            this.setState({ isSelected: true });
        }
    };
    validateAndSubmit = async (formik: FormikProps<any>) => {
        this.setState({ isSearched: true });
        let isCompleted: boolean = true;
        if (isCompleted) {
            formik.submitForm();
            this.setState({ isSelected: true });
        }
        const searched = document.getElementById('searched');
        const unsearched = document.getElementById('unsearched');
        if (unsearched && searched) {
            unsearched.className = 'd-none';
            searched.className = 'd-block';
        }
    };

    public sort = (sortKey: string, orderBy: string) => {
        this.state.filters.orderBy = sortKey + '_' + orderBy;
        this.state.filterInitialValues.page = 1;
        this.setState(this.state);
        this.props.dispatch(
            Actions.getHelpdeskList(
                this.state.filterInitialValues.status,
                this.state.filterInitialValues.categories,
                this.state.filterInitialValues.subject,
                this.state.filterInitialValues.beginCreatedDate!,
                this.state.filterInitialValues.endCreatedDate!,
                '',
                10,
                this.state.filterInitialValues.page,
                this.state.filters.orderBy ? this.state.filters.orderBy : ''
            )
        );
    };

    public onPageChange = async (page: number) => {
        this.state.filterInitialValues.page = page;
        this.setState(this.state);
        await this.getList();
    };

    formatDate() {
        const today = Moment().startOf('day');
        const messageDate = Moment(this.props.lastMessageDate);
        if (messageDate >= today) {
            return messageDate.format('H:mm');
        } else {
            return messageDate.format('D MMMM Y H:mm');
        }
    }
    splitDate() {
        let textResult = this.state.filterInitialValues.helpDeskCreateDate;
        let beginMonthResult = 0, endMonthResult = 0;

        if (textResult != undefined) {
            const beginDate = textResult.substr(0, 2);
            const beginMonthDate = textResult.substr(3, 2);
            const beginYearDate = textResult.substr(6, 4);
            const endDate = textResult.substr(13, 2);
            const endMonthDate = textResult.substr(16, 2);
            const endYearDate = textResult.substr(19, 4);
            beginMonthResult = parseInt(beginMonthDate)
            endMonthResult = parseInt(endMonthDate)
            this.state.filterInitialValues.beginCreatedDate = moment(new Date(beginYearDate, beginMonthResult - 1, beginDate)).format('YYYY-MM-DD').toString();
            this.state.filterInitialValues.endCreatedDate = moment(new Date(endYearDate, endMonthDate - 1, endDate)).format('YYYY-MM-DD').toString();


        }
    }
    showFileUploader = () => {
        this.setState({
            showFileUploader: true,
            showFileUploaderCount: this.state.showFileUploaderCount
        });
    };
    closeFileUploader = (uppy: any) => {
        this.setState({
            showFileUploader: false
        });
        this.uppyInstance = uppy;
    };
    resetFileUploader = () => {
        if (this.uppyInstance) {
            this.uppyInstance.reset();
        }
        this.setState({ fileUploaded: false, fileUploadKey: this.generateFileUploadKey() });
    };

    handleFileUploaded = (uppy: any) => {
        this.setState({
            showFileUploader: false,
            fileUploaded: true,
            showFileUploaderCount: Object.keys(uppy.store.state.files).length
        });
    
        this.uppyInstance = uppy;
    };

    fileUploadedHandler = (uppy: any) => {
        this.setState({
            fileUploaded: true,
            showFileUploaderCount: Object.keys(uppy.store.state.files).length
        });
    };

    public clickToDownload = (e: any) => {
        const filepath = e.currentTarget!.getAttribute('data-filepath').toString();
        const fileName = e.currentTarget!.getAttribute('data-filename').toString();
        if (filepath && fileName) {
            _common.DownloadLink(filepath + '/download', fileName);
        }
    };

    getQuillToolbarModule = () => {
        return (window.innerWidth > 760) ? EModuleType.basic : EModuleType.mobile
    };

    generateFileUploadKey = (): string => {
        return 'message_upload_' + this.props.identity.userId + '_' + Guid.create();
    };

    toggleEmojiPicker = () => {
        this.setState({
            showEmojiPicker: !this.state.showEmojiPicker
        });
    };

    addEmoji = (emoji: any) => {
        let text = this.state.textAreaValue;
        if (text.endsWith('</p>')) {
            text = text.slice(0, -4);
        }

        this.setState({
            textAreaValue: text + emoji.native + '</p>'
        });
    };

    public render() {
        const helpDeskListItem = this.props.helpDeskList && this.props.helpDeskList.length > 0 ? this.props.helpDeskList : [];
        const helpDeskChatItem = this.props.helpDeskChat && this.props.helpDeskChat.length > 0 ? this.props.helpDeskChat : [];
        const helpTitle = this.state.selectedHelpDeskItem.helpTitle;
        const pageValue = this.state.filterInitialValues.page;
        return (
            <div className="container pd-top-30">
                <div className="row">
                    <div className="col-md-4">
                        <h6 className="mb-3 mb-md-0 page-header">{T.t('r_gen_help_desk')}</h6>
                    </div>
                    <div className="col-md-8 text-md-right">
                        <div className="options d-inline-flex align-items-center">
                            <button onClick={this.addNewHelpModal.bind(this)} type="button" className="ml-2 category-tag-square tag-green  ">
                                <i className="material-icons mr-1 ">add</i>
                                {T.t('r_gen_create_support')}
                            </button>
                        </div>
                    </div>
                </div>
                <Formik initialValues={this.state.filterInitialValues} onSubmit={this.onSubmit}>
                    {formik => {
                        return (
                            <div className="filter-fields mt-4">
                                <form onSubmit={formik.handleSubmit} key={'project_add_user_modal'} noValidate={true}>
                                    <div className="row align-items-baseline">
                                        <div className="col-md-4 col-12">
                                            <div className="form-input form-group date-picker">
                                                <SelectAsync
                                                    isMulti={true}
                                                    isSearchable={true}
                                                    requestType={'get'}
                                                    parameter={{ SearchedText: '', SelectedIds: formik.values.categories, Take: 5 }}
                                                    placeHolder={T.t('r_add_exam_category')}
                                                    url={'api/helpdesk/categories'}
                                                    closeMenuOnScroll={false}
                                                    closeMenuOnSelect={false}
                                                    name={'categoryTypeId'}
                                                    value={formik.values.categories}
                                                    onChange={formik.handleChange}
                                                    setFieldValue={formik.setFieldValue}
                                                    errors={formik.errors.categories}
                                                    touched={formik.touched.categories}
                                                    isTouched={formik.setFieldTouched}
                                                    hasLocalization={true}
                                                    setFieldOnlyValue={true}
                                                    isClearable={true}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-12">
                                            <div className="form-input form-group date-picker">
                                                <DatetimeFormik
                                                    name={'helpDeskCreateDate'}
                                                    placeHolder={T.t('r_gen_questionBank_createdDate')}
                                                    formik={formik}
                                                    datePickerId={'helpDeskCreateDate'}
                                                    mode="range" // range mode error
                                                    time24Hr={true}
                                                    onChange={this.state.filterInitialValues.helpDeskCreateDate ? this.splitDate() : null}
                                                    static={true}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-12">
                                            <div className="form-input form-group date-picker">
                                                <SelectAsync
                                                    isMulti={false}
                                                    isSearchable={true}
                                                    requestType={'get'}
                                                    placeHolder={T.t('r_gen_status')}
                                                    parameter={{ SearchedText: '', SelectedIds: formik.values.status, Take: 5 }}
                                                    url={'api/helpdesk/statuslist'}
                                                    closeMenuOnScroll={false}
                                                    closeMenuOnSelect={true}
                                                    onChange={formik.handleChange}
                                                    name={'statusId'}
                                                    value={formik.values.status}
                                                    setFieldValue={formik.setFieldValue}
                                                    errors={formik.errors.status}
                                                    touched={formik.touched.status}
                                                    isTouched={formik.setFieldTouched}
                                                    hasLocalization={true}
                                                    setFieldOnlyValue={true}
                                                    isClearable={true}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            <div className="form-input form-group date-picker">
                                                <Input
                                                    type={'text'}
                                                    name={'subject'}
                                                    label={T.t('r_gen_search_support')}
                                                    onChange={formik.handleChange}
                                                    formik={formik}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="text-right pt-3" style={{ paddingBottom: 10 }}>
                                        <button
                                            onClick={() => {
                                                this.validateAndSubmit(formik);
                                            }}
                                            disabled={formik.isSubmitting}
                                            className="ml-2 category-tag-square tag-green"
                                        >
                                            {T.t('r_gen_search')} <i className="material-icons material-icons-search">search</i>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        );
                    }}
                </Formik>

                <div className="page-table helpDesk-table p-0 m-t-0" id="getHelpDesktList_Content">
                    <Table
                        className="table-user-list table-striped table-ellipsis table-mobile mt-4"
                        striped={true}
                        hover={true}
                        borderless={true}
                    >
                        {helpDeskListItem && helpDeskListItem.length > 0 ? (
                            <thead>
                                <tr style={{ backgroundColor: '#eaeaea' }}>
                                    <SortedColumn
                                        datacell="helpDeskStatusText"
                                        className="d-lg-table-cell d-xl-table-cell  ml-1 text-center"
                                        title={T.t('r_helpdesk_list_status')}
                                        sortkey="helpDeskStatusText"
                                        sortedcolumn={this.state.filters.orderBy}
                                        sort={this.sort}
                                    />
                                    <SortedColumn
                                        datacell="assignedUser"
                                        className="d-lg-table-cell d-xl-table-cell text-center"
                                        title={T.t('r_helpdesk_list_assigned_user')}
                                        sortkey="assignedUser"
                                        sortedcolumn={this.state.filters.orderBy}
                                        sort={this.sort}
                                    />
                                    <SortedColumn
                                        datacell="subject"
                                        className="d-lg-table-cell d-xl-table-cell text-center"
                                        title={T.t('r_helpdesk_list_header')}
                                        sortkey="subject"
                                        sortedcolumn={this.state.filters.orderBy}
                                        sort={this.sort}
                                    />
                                    <SortedColumn
                                        datacell="createdDate"
                                        className="d-lg-table-cell d-xl-table-cell text-center"
                                        title={T.t('r_helpdesk_list_date')}
                                        sortkey="createdDate"
                                        sortedcolumn={this.state.filters.orderBy}
                                        sort={this.sort}
                                    />
                                </tr>
                            </thead>
                        ) : (
                            ''
                        )}
                        {helpDeskListItem && helpDeskListItem.length > 0 ? (
                            <tbody>
                                {helpDeskListItem.map((item: IHelpdeskListItem) => {
                                    return (
                                        <tr
                                            onClick={() => {
                                                this.onMessageClick(item.helpDeskId, item.helpDeskIdRef, item.message);
                                            }}
                                            key={'helpdeskItem-' + item.helpDeskId}
                                            data-title={item.helpDeskId}
                                            style={{ cursor: 'initial' }}
                                        >
                                            <td data-label={T.t('r_helpdesk_list_status')} className="text-left">
                                                <div className={'click'} style={{ textAlign: "center",cursor: "pointer" }}>
                                                    <span
                                                        style={{ minWidth: '72px', padding: '6px' }}
                                                        className={'badge badge-pill badge-'.concat(
                                                            item.helpDeskStatusText === 'r_helpdesk_status_Closed' ? 'primary' :
                                                                item.helpDeskStatusText === 'r_helpdesk_status_Process' ? 'warning text-light' : 'success'
                                                        )}
                                                    >
                                                        {item.helpDeskStatusText === 'r_helpdesk_status_Closed' ? T.t('r_helpdesk_status_Closed') :
                                                            item.helpDeskStatusText === 'r_helpdesk_status_Process' ? T.t('r_helpdesk_status_Process') : T.t('r_helpdesk_status_Open')}
                                                    </span>
                                                </div>
                                            </td>
                                            <td data-label={T.t('r_helpdesk_list_assigned_user')} className="text-left">
                                                {item.assignedUser}
                                            </td>
                                            <td data-label={T.t('r_helpdesk_list_header')} className="text-center">
                                                {item.subject}
                                            </td>
                                            <td data-label={T.t('r_helpdesk_list_date')} className="text-center">
                                                {moment(item.createdDate).format('DD.MM.YYYY, HH:mm')}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        ) : (
                            <div
                                className="d-flex flex-column align-items-center justify-content-center"
                            >
                                <img style={{ marginTop: '2em', marginBottom: '1em' }} src={imgAnn} />

                                <h5 id="searched" className="d-block" style={{ marginTop: 15, textAlign: 'center', marginBottom: 15 }}>
                                    {T.t('r_gen_not_created_help')}
                                </h5>
                                <p>{T.t('r_gen_create_help_support')}</p>
                            </div>
                        )}
                    </Table>
                    <div className="row-options justify-content-end">
                        <div className="page-sorting d-flex align-items-center justify-content-center" style={{ marginTop: '5px' }}>
                            {this.props.helpDeskList && this.props.helpDeskList.length > 0 && (
                                <Paginate
                                    class={'custom-paginate'}
                                    filters={{
                                        take: this.props.helpDeskListTake!,
                                        skip: this.props.helpDeskListPage,
                                        total: this.props.helpDeskListTotalCount!,
                                        page: this.state.filterInitialValues.page
                                    }}
                                    onPageChange={this.onPageChange}
                                ></Paginate>
                            )}
                        </div>
                    </div>
                </div>

                {/* create modal */}

                <Modal
                    isOpen={this.state.isHelpModalOpen}
                    toggle={this.setCloseHelpModal}
                    modalClassName={'add-activity-modal modal-from-right slideInRight show animated'}
                    fade={true}
                    style={{ display: 'block', animationDuration: '0.5s' }}
                    backdrop={'static'}
                    id={'add_new_activity'}
                >
                    <div className="modal-dialog" role="document" style={{ width: '40vw', height: window.innerHeight }}>
                        <div className="modal-content" style={{ height: window.innerHeight }}>
                            <div className="modal-header d-flex justify-content-start">
                                <h5 className="modal-title d-flex align-items-center">{T.t('r_gen_create_support')}</h5>
                                <button
                                    onClick={this.setCloseHelpModal}
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <i style={{ color: '#000' }} className="material-icons">
                                        close
                                    </i>
                                    <span>{T.t('r_gen_close')}</span>
                                </button>
                            </div>
                            <div className=" modal-body p-3">
                                <div className="row mt-0">
                                    <Formik initialValues={this.state.filterInitialValues} onSubmit={this.onCreateSubmit}>
                                        {formik => {
                                            return (
                                                <form style={{ position: 'relative', height: 'calc(110vh - 92px)' }} onSubmit={formik.handleSubmit} key={'project_add_user_modal'} noValidate={true}>
                                                    <div className="row align-items-baseline" style={{ padding: '0 1em', marginTop: 0 }}>
                                                        <div className="col-12">
                                                        <h5 className="mt-4 mb-2">{T.t('r_gen_create_helpDesk_subject')} <span className="ml-1" style={{ color: '#dc5050' }}>
                                    *
                                </span></h5>
                                                            <Input
                                                                type={'text'}
                                                                name={'createSubject'}
                                                                label={T.t('r_gen_create_helpDesk_subject')}
                                                                onChange={formik.handleChange}
                                                                formik={formik}
                                                            />
                                                            <div className="form-input form-group date-picker" style={{ marginTop: 10 }}>
                                                            <h5 className="mt-4 mb-2">{T.t('r_add_exam_category')} <span className="ml-1" style={{ color: '#dc5050' }}>
                                    *
                                </span></h5>
                                                                <SelectAsync
                                                                    isMulti={false}
                                                                    isSearchable={true}
                                                                    requestType={'get'}
                                                                    parameter={{
                                                                        SearchedText: '',
                                                                        SelectedIds: formik.values.categories,
                                                                        Take: 5
                                                                    }}
                                                                    placeHolder={T.t('r_add_exam_category')}
                                                                    url={'api/helpdesk/categories'}
                                                                    closeMenuOnScroll={false}
                                                                    closeMenuOnSelect={true}
                                                                    name={'categoryTypeId'}
                                                                    value={formik.values.categories}
                                                                    onChange={formik.handleChange}
                                                                    setFieldValue={formik.setFieldValue}
                                                                    errors={formik.errors.categories}
                                                                    touched={formik.touched.categories}
                                                                    isTouched={formik.setFieldTouched}
                                                                    hasLocalization={true}
                                                                    setFieldOnlyValue={true}
                                                                    isClearable={true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-12">
                                                            <h5 className="mt-4 mb-2">{T.t('r_description')} <span className="ml-1" style={{ color: '#dc5050' }}>
                                    *
                                </span></h5>
                                                            <Quil
                                                                modules={'basic'}
                                                                placeholder={T.t('r_gen_help_desc')}
                                                                value={this.state.description}
                                                                theme={'snow'}
                                                                onChange={this.descriptionOnChange}
                                                            />
                                                        </div>

                                                        {/* <div className="col-12">
                                                            <h5 className="mt-4 mt-0">{T.t('r_fileUpload_dashboardTitle')}</h5>
                                                            <div className="upload-image text-center mb-1">
                                                                <FileUpload
                                                                    key={this.props.fileInputKey}
                                                                    fileInputKey={this.props.fileInputKey?this.props.fileInputKey:''} //fill in here
                                                                    height={300}
                                                                    maxFileSize={2000000000}
                                                                    isCardImage={false}
                                                                    maxSelectedFileCount={1}
                                                                    //activityType={ActivityTypeEnums.Assignment}
                                                                />
                                                            </div>
                                                        </div> */}
                                                    </div>
                                                    <div className="modal-footer d-block" style={{ position: 'absolute', minWidth: '101%',  bottom: '0', insetInlineStart: "-1px" }}>
                                                        <div className="row">
                                                            <div className="col-md">
                                                                <button
                                                                    onClick={this.setCloseHelpModal}
                                                                    type="button"
                                                                    className="btn btn-gray"
                                                                >
                                                                    {T.t('r_cancel_button')}
                                                                </button>
                                                            </div>
                                                            <div className="col-md text-md-right">
                                                                <button
                                                                    onClick={() => {
                                                                        this.createAndSubmit(formik);
                                                                    }}
                                                                    disabled={this.state.isLoadingProcess}
                                                                    type="button"
                                                                    className="btn btn-success mobile-margin ml-2"
                                                                >
                                                                    {this.state.isLoadingProcess ? T.t('r_gen_saving') : T.t('r_gen_save')}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            );
                                        }}
                                    </Formik>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>

                {/* helpdesk chat modal */}
                <Modal
                    id="chatpanel-popup"
                    style={{ width: '100%',     
                        height: '100%',
                        display: 'flex',    
                        justifyContent: 'center',
                        alignItems: 'center',}}
                    keyboard={false}
                    isOpen={this.state.ishelpDeskChatModalOpen}
                    toggle={this.setCloseShowHelpModal}
                    contentClassName={' chat_modal_width'}
                    modalClassName={'survey-modal-fade'}
                >
                    <div className="modal-header d-flex justify-content-start mobile_chat_padding " style={{ padding: '.5em ' }}>
                        <div className="conversation-header d-flex align-items-center justify-content-between w-100">
                            <div className="userinfo media align-items-center">
                                <div className="media-body">
                                    <span className="d-flex">
                                        <i className="material-icons mr-2">support_agent</i>
                                        {this.state.selectedHelpDeskItem.subject}
                                    </span>
                                </div>
                            </div>

                            <button type="button" className="close ml-0" onClick={this.setCloseShowHelpModal} aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                    </div>
                    <div className="modal-content">
                        <div className="modal-body p-0">
                            <div className="row" style={{ marginTop: 0 }}>
                                <div className="col-12">
                                    <div className="conversation-popup relative ">
                                        <div
                                            className="conversation-container d-flex flex-column"
                                            style={{ maxHeight: '60vh', padding: '0 2em' }}
                                        >
                                            {helpDeskChatItem &&
                                                helpDeskChatItem.length > 0 &&
                                                helpDeskChatItem.map((chatItem: IHelpDeskChatItem, index) => {
                                                    return (
                                                        <div
                                                            className={
                                                                'message-bar d-flex flex-column m-p-0 ' +
                                                                (chatItem.isOwnerMessage ? 'align-self-end right' : '')
                                                            }
                                                            style={{ margin: '8px 0px 8px 0', width: 'fit-content' }}
                                                            key={'helpdeskChatItem-' + chatItem.forumMessageId}
                                                        >
                                                            <div className="userinfo media align-items-center">
                                                                <div className="media-body ml-1">
                                                                    <span
                                                                        className={
                                                                            'd-flex ' +
                                                                            (chatItem.isOwnerMessage
                                                                                ? 'justify-content-end'
                                                                                : 'justify-content-start')
                                                                        }
                                                                    >
                                                                        {chatItem.replyUser}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div //left right changes
                                                                className={
                                                                    'message-content message-right-menu ' +
                                                                    (chatItem.isOwnerMessage ? 'own-message' : 'other-message')
                                                                    + (!_common.isArabic(chatItem.message, document.body.getAttribute('dir')) ? ' arabic-text-direction' : '')
                                                                }
                                                                style={{
                                                                    float: chatItem.isOwnerMessage ? 'right' : 'left',
                                                                    marginRight: chatItem.isOwnerMessage ? '0px' : '',
                                                                    marginLeft: 0
                                                                }}
                                                            >
                                                                <p style={{ maxWidth: '400px' }}>
                                                                    <div dangerouslySetInnerHTML={{ __html:chatItem.message && chatItem.message}}/>
                                                                    <div
                                                                        className={
                                                                            'dropdown ' +
                                                                            (chatItem.isOwnerMessage ? 'own-dropdown' : 'other-dropdown')
                                                                        }
                                                                        id="messageDots"
                                                                    >
                                                                        <a
                                                                            data-toggle="dropdown"
                                                                            href="javascript:;"
                                                                            onClick={() => {
                                                                                this.setState({
                                                                                    //first value is coming undefined
                                                                                    selectedHelpDeskMessageId: chatItem.forumMessageId,
                                                                                    helpDeskMessage: chatItem.message
                                                                                });
                                                                            }}
                                                                        >

                                                                            {chatItem.isOwnerMessage ? (
                                                                                <img src={_common.GetDefaultIcons('dots')} alt="dots" />
                                                                            ) : (
                                                                                ''
                                                                            )}
                                                                        </a>
                                                                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                                            <a //for delete
                                                                                className="dropdown-item"
                                                                                href="javascript:;"
                                                                                onClick={this.deleteHandler.bind(this)}
                                                                            >
                                                                                {T.t('r_gen_delete_message')}
                                                                            </a>
                                                                        </div>
                                                                    </div>

                                                                </p>
                                                                {chatItem.fileId ?
                                                                    <div className="row">
                                                                        <div className="upload-files-name pl-3 pr-3">
                                                                  
                                                                        <button
                                                                           
                                                                            type="button"
                                                                            className="file-name mr-3 mb-3 float-left"
                                                                            onClick={this.clickToDownload}
                                                                            data-filename={chatItem.mesageFile && chatItem.mesageFile.file}
                                                                            style={{
                                                                                display: 'flex',
                                                                                border: '1px solid rgb(238, 238, 238)',
                                                                                boxShadow: 'rgba(0, 0, 0, 0.2) 3px 3px 5px 1px'
                                                                            }}
                                                                        >
                                                                            <i
                                                                                className="mr-1 material-icons"
                                                                                style={{ verticalAlign: 'middle' }}
                                                                            >
                                                                                attach_file
                                                                            </i>
                                                                            {chatItem.mesageFile?.fileName}
                                                                            <span
                                                                                className="ml-2 mb-0"
                                                                                style={{ verticalAlign: 'inherit', marginTop: '1px' }}
                                                                            >
                                                                                {_common.BytesToSize(chatItem.mesageFile ? parseInt(chatItem.mesageFile.size, 10) : 0)}
                                                                            </span>
                                                                        </button>
                                                                  
                                                                </div>
                                                                    </div>
                                                                    : ''}
                                                            </div>
                                                            <i
                                                                style={{
                                                                    fontSize: '12px',
                                                                    color: '#908F8D',
                                                                    marginLeft: !chatItem.replyUser ? 'auto' : ''
                                                                }}
                                                            >
                                                                {chatItem.isOwnerMessage ?
                                                                    moment(chatItem.createdDate).format('DD.MM.YYYY, HH:mm ')
                                                                    : moment(chatItem.lastMessageDate).format('DD.MM.YYYY, HH:mm ')}
                                                            </i>
                                                        </div>
                                                    );
                                                })}
                                                 <div ref={this.messagesEndRef} />
                                        </div>
                                    </div>
                                    <div className="type-message-field w-100  message-field-position" style={{ padding: '5px 0' }}>
                                        <div className="input-group d-block" style={{ padding: '0' }}>
                                            <div style={{ display: 'none' }} className="message-input-warning" />
                                            <Quil
                                                ref={ref => { this.quillRef = ref }}
                                                modules={this.getQuillToolbarModule()}
                                                placeholder={T.t('r_message_place_holder')}
                                                onChange={this.messageOnChange}
                                                className={'custom-quill-message'}
                                                value={this.state.messageTextAreaValue ? this.state.messageTextAreaValue : ''}
                                                theme={'snow'}
                                            />
                                            <div className="input-group-append">
                                                {this.state.getQuillToolbarModule !== EModuleType.mobile ? (
                                                    <div>
                                                        {this.state.showEmojiPicker ? (                                                            
                                                            <ChatEmojiPicker
                                                                onSelect={this.addEmoji}
                                                                handleClickOutside={this.toggleEmojiPicker}
                                                                ref={e => (this.chatEmojiPicker = e)}
                                                                locale={T.i18next.language}
                                                            />
                                                        ) : null}
                                                        <div>
                                                            <span className="input-group-text" onClick={this.toggleEmojiPicker}>
                                                                <i className="material-icons">tag_faces</i>
                                                            </span>      
                                                        </div>
                                                        {this.state.fileUploaded ? (
                                                <div style={{ position: 'absolute', right: '105px', bottom: '43px' }}>
                                                    <span
                                                        style={{ height: '16px', color: 'orange', marginLeft: '-10px' }}
                                                        className="badge badge-pill badge-light"
                                                    >
                                                        {this.state.showFileUploaderCount}
                                                    </span>
                                                    <span
                                                        style={{ height: '16px', color: 'red', marginLeft: '0px', cursor: 'pointer' }}
                                                        title="Dosyayı sil"
                                                        className="badge badge-pill badge-light"
                                                    >
                                                        x
                                                    </span>
                                                </div>
                                            ) : null}
                                                    </div>
                                                ) : null}
                                                 <span className="input-group-text" onClick={this.showFileUploader}>
                                                                    <i className="material-icons">add</i>
                                                                </span>
                                                <a onClick={this.sendHandler.bind(this)} className="input-group-text">
                                                    <i style={{ marginRight: '5px' }} className="material-icons">
                                                        send
                                                    </i>
                                                    <div>{T.t('r_send')}</div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                     
                    {
                        this.state.showFileUploader ?
                        <div className="upload-image text-center mb-1">
                            <FileUpload
                        key={this.state.fileUploadKey}
                        fileInputKey={this.state.fileUploadKey}
                        height={250}
                        maxFileSize={10000000}
                        maxSelectedFileCount={5}
                        isCardImage={false}
                        isModal={true}
                        modalOpen={this.state.showFileUploader}
                        handleModalClose={this.closeFileUploader}
                        triggerFileUpload={this.handleFileUploaded}
                        activityType={ActivityTypeEnums.Forum}
                    />
                        </div>
                        
                            :
                            null
                        
                    }
                    
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IHelpDeskProps): IHelpDeskProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IHelpDeskProps = Object.assign({}, ownProps, {
        categories: state.helpDesk.categories,
        status: state.helpDesk.status,
        beginCreatedDate: state.helpDesk.beginCreatedDate,
        endCreatedDate: state.helpDesk.endCreatedDate,
        helpDeskList: state.helpDesk.helpDeskList,
        helpDeskListPage: state.helpDesk.helpDeskListPage,
        helpDeskListTake: state.helpDesk.helpDeskListTake,
        helpDeskListTotalCount: state.helpDesk.helpDeskListTotalCount,
        helpDeskChat: state.helpDesk.helpDeskChat,
        HelpDeskStatusText: state.helpDesk.HelpDeskStatusText,
        identity: state.login.identitiy,
        moduleItems: state.login.login.moduleItems
    });

    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret =
        next.helpDesk.helpDeskList === prev.helpDesk.helpDeskList &&
        next.helpDesk.helpDeskChat === prev.helpDesk.helpDeskChat &&
        next.helpDesk.helpDeskListPage === prev.helpDesk.helpDeskListPage &&
        next.helpDesk.helpDeskListTake === prev.helpDesk.helpDeskListTake &&
        next.helpDesk.helpDeskListTotalCount === prev.helpDesk.helpDeskListTotalCount &&
        next.login.identitiy === prev.login.identitiy
        ;
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CHelpDeskMain = connect(mapStateToProps, dispatchProps, null, { areStatesEqual })(HelpDeskMain);

export default CHelpDeskMain;
